var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-policy-form',{staticClass:"pt-policy-form__page",attrs:{"isEdit":_vm.is_edit,"id":_vm.id,"policyType":_vm.policyType,"isIntegral":_vm.is_integral}})}
var staticRenderFns = []

export { render, staticRenderFns }